"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../../styles/components/loading-indicator.less");
const SIZE_DEFAULT = '16';
const HEIGHT_DEFAULT = '100';
const CLASS_NAME_DEFAULT = '';
const LoadingIndicator = ({ size = SIZE_DEFAULT, height = HEIGHT_DEFAULT, className = CLASS_NAME_DEFAULT }) => {
    const wrapperStyle = {
        height: `${height}px`,
    };
    const bounceStyle = {
        width: `${size}px`,
        height: `${size}px`,
    };
    return (react_1.default.createElement("div", { className: `loading-indicator ${className}` },
        react_1.default.createElement("div", { className: "loading-indicator-wrapper", style: wrapperStyle },
            react_1.default.createElement("div", { className: "new-spinner" },
                react_1.default.createElement("div", { className: "spinner" },
                    react_1.default.createElement("div", { className: "bounce1", style: bounceStyle }),
                    react_1.default.createElement("div", { className: "bounce2", style: bounceStyle }),
                    react_1.default.createElement("div", { className: "bounce3", style: bounceStyle }))))));
};
exports.default = LoadingIndicator;
//# sourceMappingURL=loading-indicator.js.map